module.exports = __webpack_public_path__ + "static/media/IMG_0148.37cbf46d.jpg";